
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import moment from "moment";
@Component({
  name: 'DatetimePickerDialog'
})
export default class DatetimePickerDialog extends Vue {
  @Prop() time?: any
  showDialog = false
  currentDate = new Date()
  minDate = new Date('2024/10/1')
  // minDate = new Date('2024-10-1') // IOS无法渲染组件，IOS不支持中划线分割的日期格式

  @Watch('time', { immediate: true })
  changeTime (val: any) {
    if (val) {
      console.log(val)
      this.currentDate = new Date(val)
    }
  }

  show (data) {
    this.showDialog = true
  }

  onCancel () {
    this.showDialog = false
  }

  onConfirm () {
    let dateTime = moment(this.currentDate).format("YYYY-MM-DD")
    this.$emit('getDateTime', dateTime)
    this.showDialog = false
  }
}
